import { combineReducers } from 'redux'
import * as AT from '../actions/_types'

const resetConversationState = () => ({
  id: null, // {number} which convo am I looking at right now?
  isEmail: false, // {bool} is the current convo that I'm viewing an email?
  isBlastMsg: false, // {bool} am I looking at a blast message?
  hasBodyText: false, // {bool} will we need to discard the drafted message before moving to another conversation?
})

const conversation = (prevState = resetConversationState(), action) => {
  switch (action.type) {
    case AT.CURR_CHOOSE_CONVERSATION: {
      return {
        ...prevState,
        id: action.conversationId,
        isBlastMsg: false,
      }
    }
    case AT.CURR_RESET_CONVERSATION: {
      return {
        ...resetConversationState(),
      }
    }
    case AT.CURR_CONVERSATION_IS_EMAIL: {
      return {
        ...prevState,
        isEmail: action.isEmail,
        isBlastMsg: false,
      }
    }
    case AT.CURR_CONVERSATION_HAS_BODY: {
      return {
        ...prevState,
        hasBodyText: action.hasBodyText,
      }
    }
    case AT.BLASTS_PREPARE: {
      return {
        ...prevState,
        isEmail: action.isEmail,
        isBlastMsg: true,
        id: null,
      }
    }
    case AT.BLASTS_FETCH_FAIL:
    case AT.BLASTS_FETCH_SUCC: {
      return {
        ...prevState,
        isEmail: action.isEmail,
        isBlastMsg: false,
        id: null,
      }
    }
    default: {
      return prevState
    }
  }
}

// TODO: since there's just 1 reducer, see if there are issues with exporting
// that directly instead of doing combineReducers
export default combineReducers({
  conversation,
})



// WEBPACK FOOTER //
// ./src/state/reducers/current.js